import { render, staticRenderFns } from "./TipoFiscalForm.vue?vue&type=template&id=6c892484"
import script from "./TipoFiscalForm.vue?vue&type=script&lang=js"
export * from "./TipoFiscalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports